import styled, { css } from 'styled-components';

import { Accordion } from '@/components/Accordion';
import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';
import { Typography } from '@/components/Typography';

import backgroundWatchSvg from '@/assets/backgroundWatch.svg';
import { ReactComponent as InfoBadge } from '@/assets/icons/info-badge.svg';

export const Wrapper = styled(Container)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      background-color: initial;
    }
  `}
`;

export const InnerWrapper = styled(Box)<{
  showBackground?: boolean;
}>`
  width: 100%;

  ${({ showBackground, theme }) =>
    showBackground &&
    css`
      ${theme.media.md.up} {
        background: url(${backgroundWatchSvg}) no-repeat right;
      }
    `}
`;

export const Section = styled(Box)`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.tertiaryGrey};
    padding-bottom: ${theme.spacing(2)};

    ${theme.media.md.up} {
      border: none;
      width: 100%;
      margin-right: ${theme.spacing(6)};
      padding-bottom: initial;
    }
  `}
`;

export const SectionHeaderWrapper = styled(Box)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(5)};
  `}
`;

export const Title = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    padding: ${theme.spacing(2)} 0;

    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.p1};
    }
  `}
`;

export const NameValueWrapper = styled(Flex)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      flex-direction: column;

      :not(:last-child) {
        margin-bottom: ${theme.spacing(3)};
      }
    }
  `}
`;

export const Name = styled(Typography)`
  width: 50%;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    line-height: ${theme.lineHeights.p1};
    color: ${theme.colors.darkGrey};
    margin-right: ${theme.spacing(1)};

    ${theme.media.md.up} {
      width: initial;
    }
  `}
`;

export const Value = styled(Typography)`
  display: inline;
  ${({ theme }) => css`
    line-height: ${theme.lineHeights.p1};

    ${theme.media.md.up} {
      width: initial;
    }
  `}
`;

export const ValueBox = styled(Box)`
  width: 50%;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      width: 100%;
    }
  `}
`;

export const IconWrapper = styled.span`
  vertical-align: middle;
  margin-left: 5px;
  height: 100%;
`;

export const InfoBadgeIcon = styled(InfoBadge)`
  width: 12px;
  height: 13px;
  &:hover {
    cursor: pointer;
  }
`;

export const SectionWrapper = styled(Flex)<{ $isExpand?: boolean }>`
  position: relative;
  overflow: hidden;
  ${({ $isExpand }) => css`
    height: ${$isExpand ? 'auto' : '220px'};
  `}
`;

export const Overlay = styled(Box)`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 20px;
    background: linear-gradient(to top, #fff, transparent);
  }
`;

export const OverlayWrapper = styled(Flex)`
  background: #fff;
  justify-content: center;
  align-items: center;
`;

export const LoadMore = styled(LegacyButton)`
  text-decoration: none;
`;

export const StyledAccordion = styled(Accordion)`
  .AccordionBox {
    ${({ theme }) => css`
      padding: ${theme.spacing(2)};
      background-color: ${theme.colors.secondaryLightGrey};
    `}
  }
`;
